import {createContext, Dispatch, FunctionComponent, Reducer, useReducer, useState} from "react";
import SessionReducer from "src/context/reducers/SessionReducer";
import SessionInitialState from "src/context/states/SessionInitialState";
import SectionsReducer from "src/context/reducers/SectionsReducer";
import SectionInitialState from "src/context/states/SectionInitialState";
import MetadataReducer from "src/context/reducers/MetadataReducer";
import MetadataInitialState from "src/context/states/MetadataInitialState";
import {IAction} from "src/context/IAction";
import EventReducer from "src/context/reducers/EventReducer";
import EventInitialState from "src/context/states/EventInitialState";
import {IEventState} from "src/context/models/Event";
import {IMetadataState} from "src/context/models/Metadata";
import {ISectionState} from "src/context/models/Section";
import {ISessionState} from "src/context/models/Session";

export interface IGlobalState {
    sessionState: ISessionState,
    sessionDispatch: Dispatch<IAction>,
    sectionsState: ISectionState,
    sectionsDispatch: Dispatch<IAction>,
    metadataState: IMetadataState,
    metadataDispatch: Dispatch<IAction>,
    eventState: IEventState,
    eventDispatch: Dispatch<IAction>
}

export const globalState: IGlobalState = {
    sessionState: SessionInitialState,
    sessionDispatch: () => null,
    sectionsState: SectionInitialState,
    sectionsDispatch: () => null,
    metadataState: MetadataInitialState,
    metadataDispatch: () => null,
    eventState: EventInitialState,
    eventDispatch: () => null
}

export const GlobalContext = createContext(globalState);

export const GlobalProvider: FunctionComponent = (props) => {
    const [sessionState, sessionDispatch] = useReducer<Reducer<ISessionState, IAction>>(SessionReducer, SessionInitialState);
    const [sectionsState, sectionsDispatch] = useReducer<Reducer<ISectionState, IAction>>(SectionsReducer, SectionInitialState);
    const [metadataState, metadataDispatch] = useReducer<Reducer<IMetadataState, IAction>>(MetadataReducer, MetadataInitialState);
    const [eventState, eventDispatch] = useReducer<Reducer<IEventState, IAction>>(EventReducer, EventInitialState);

    return (
        <GlobalContext.Provider
            value={{
                sessionState,
                sessionDispatch,
                sectionsState,
                sectionsDispatch,
                metadataState,
                metadataDispatch,
                eventState,
                eventDispatch
            }}
        >
            {props.children}
        </GlobalContext.Provider>
    );
};